export const PortalHostNames = {
  DRAG_DROP: "DRAG_DROP",
} as const;
